import { TextTypography } from '@hh.ru/magritte-ui';

export const CELL_TYPOGRAPHY: TextTypography = 'label-2-regular';
export const MOBILE_CELL_TYPOGRAPHY: TextTypography = 'label-3-regular';

export const EMPTY_VALUE = '—';
